/**
 * GuestLayout - Layout для гостевых страниц
 */

import React, { useState, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuthContext } from "../../contexts/AuthContext/AuthProvider";
import GuestMenu from "../menus/GuestMenu";

const GuestLayout = ({ children, showHeader = true, showFooter = true }) => {
    const { isAuthenticated } = useAuthContext();
    const navigate = useNavigate();
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    // стабильный колбэк для передачи в модал — предотвращает перезапуск эффекта
    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    const handleLoginClick = () => {
        navigate("/login");
    };

    return (
        <div className="app-container">
            <div className="main-container main-container--quest">
                {showHeader && (
                    <header className="header">
                        <div>
                            <button
                                className="burger-button"
                                onClick={() => openBurgerFn && openBurgerFn()}
                                aria-label="Меню"
                            >
                                <div></div>
                            </button>
                            <GuestMenu onTrigger={handleSetOpenBurger} />
                        </div>

                        <div className="header-right">
                            {isAuthenticated ? (
                                <>
                                    <button className="user-cabinet-button">
                                        <Link to="/ucp">Личный кабинет</Link>
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        className="user-cabinet-button"
                                        onClick={handleLoginClick}
                                    >
                                        Личный кабинет
                                    </button>
                                </>
                            )}
                            <div className="logo-container">
                                <img
                                    src="/media/logo_medieval.png"
                                    alt="Logo"
                                />
                            </div>
                        </div>
                    </header>
                )}

                <main>{children}</main>
            </div>
            {showFooter && (
                <footer className="footer">
                    <p>© 2026 Medieval Roleplay</p>
                    <p>
                        <a
                            href="https://forum.medieval-rp.net/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Форум
                        </a>
                    </p>
                    <p>
                        <a
                            href="https://wiki.medieval-rp.net/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Wiki
                        </a>
                    </p>
                </footer>
            )}
        </div>
    );
};

export default GuestLayout;
